<div class="container">

  <div class="steps">
    <div class="step" [ngClass]="{'incomplete': numericalProgress < 10}">
      @if (numericalProgress < 10) {
        <i class="far fa-circle"></i>
      }
      @if (numericalProgress >= 10) {
        <i class="far fa-check-circle green"></i>
      }
      <p>Gathering statement data...</p>
    </div>

    <div class="step" [ngClass]="{'incomplete': numericalProgress < 30}">
      @if (numericalProgress < 30) {
        <i class="far fa-circle"></i>
      }
      @if (numericalProgress >= 30) {
        <i class="far fa-check-circle green"></i>
      }
      <p>Calculating cash flow and trend data...</p>
    </div>

    <div class="step" [ngClass]="{'incomplete': numericalProgress < 60}">
      @if (numericalProgress < 60) {
        <i class="far fa-circle"></i>
      }
      @if (numericalProgress >= 60) {
        <i class="far fa-check-circle green"></i>
      }
      <p>Generating trailing twelve months...</p>
    </div>

    <div class="step" [ngClass]="{'incomplete': numericalProgress < 90}">
      @if (numericalProgress < 90) {
        <i class="far fa-circle"></i>
      }
      @if (numericalProgress >= 90) {
        <i class="far fa-check-circle green"></i>
      }
      <p>Interpolating missing periods...</p>
    </div>

    <div class="step" [ngClass]="{'incomplete': numericalProgress < 98}">
      @if (numericalProgress < 98) {
        <i class="far fa-circle"></i>
      }
      @if (numericalProgress >= 98) {
        <i class="far fa-check-circle green"></i>
      }
      <p>Checking accuracy...</p>
    </div>
  </div>

  <div class="descriptions">
    @if (numericalProgress < 10) {
      <div>
        <i class="fas fa-hourglass-half bounce"></i>
        <p>Gathering statement data...</p>
      </div>
    }

    @if (numericalProgress >= 10 && numericalProgress < 30) {
      <div>
        <i class="far fa-money-bill-alt bounce"></i>
        <p>Calculating cash flow and trend data...</p>
      </div>
    }

    @if (numericalProgress >= 30 && numericalProgress < 60) {
      <div>
        <i class="far fa-calendar-check bounce"></i>
        <p>Generating trailing twelve months...</p>
      </div>
    }

    @if (numericalProgress >= 60 && numericalProgress < 90) {
      <div>
        <i class="fas fa-history bounce"></i>
        <p>Interpolating missing periods...</p>
      </div>
    }

    @if (numericalProgress >= 90 && numericalProgress < 99) {
      <div>
        <i class="fas fa-check-double bounce"></i>
        <p>Checking accuracy...</p>
      </div>
    }

    @if (numericalProgress == 99) {
      <div>
        <i class="fas fa-birthday-cake bounce"></i>
        <p>Finalizing...</p>
      </div>
    }

    @if (numericalProgress == 100) {
      <div>
        <i class="fas fa-rocket bounce"></i>
      </div>
    }

  </div>

  <div class="progress-wrapper">
    <div class="progress" [style.width]="progressWidth"></div>
  </div>
